import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// トスアップ商材一覧取得
export async function getSaleCompanyTossUpProductCloserCompanys(id: string) {
  try {
    const path = "saleCompanyTossUpProductCloserCompanys";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      closer_company_data: response.data.closer_company_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// トスアップ商材登録
export async function postSaleCompanyTossUpProductCloserCompanys(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompanyTossUpProductCloserCompanys";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
